import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import type { AccountDetailPayload } from '../account-detail.model';
import type { AccountPathType } from '../account-path-type';
import { ACCOUNTS_API } from '../accounts-api.token';

@Injectable()
export class AccountDetailStore {
  private readonly _api = inject(ACCOUNTS_API);

  private readonly _payload = signal<AccountDetailPayload | null>(null);
  private readonly _loading = signal(false);
  private readonly _error = signal<unknown | null>(null);

  readonly payload = this._payload.asReadonly();
  readonly loading = this._loading.asReadonly();
  readonly error = this._error.asReadonly();

  async load(guid: string, pathType: AccountPathType, id: string): Promise<void> {
    this._loading.set(true);
    this._error.set(null);
    try {
      const payload = await firstValueFrom(this._api.getAccount(guid, pathType, id));
      this._payload.set(payload);
    } catch (err) {
      console.error('[accounts] detail load failed');
      this._error.set(err);
      this._payload.set(null);
    } finally {
      this._loading.set(false);
    }
  }
}
